export default __webpack_public_path__ + "static/media/b.5bcad515.jpg";